// 路由列表
import PayRebate from "../views/PayRebate";
import PayFeedback from "../views/PayFeedback";

const routesList = [
  {
    path: "/kol/rebates/:kolId",
    name: "众引合作-返点支付",
    element: <PayRebate />,
  },
  {
    path: "/kol/feedback/:kolId",
    name: "众引合作-返点支付",
    element: <PayFeedback />,
  },
];

export default routesList;
